import { Box, IconButton } from '@material-ui/core'
import { ReceiptSharp, RemoveRedEye, VerifiedSharp } from '@mui/icons-material'
import CheckIcon from '@mui/icons-material/Check'

import LinkIcon from '@mui/icons-material/Link'
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium'
import moment from 'moment/moment'
import { useNavigate } from 'react-router'
const bgRoles = [
  {
    role: 'Owner',
    bg: 'orange',
  },
  {
    role: 'Delegator',
    bg: '#1976d2',
  },
]
const colors = [
  '#2e7d32', // 0 green
  'orange', // 1
  '#d32f2f', // 2 red
  '#1976d2', // 3 blue
  '#ced4da', // 4 gray
]
export const handleLRAR = (convocation, ag_id, translate, getPreviewFile) => {
  // sent - gray  / error - red / received - green
  const lrar = convocation.lrar
  if (!lrar) {
    return null
  }
  let error = false
  let color = colors[4]

  switch (lrar.status) {
    case 'electronic.accepted':
    case 'distributed':
      color = colors[0]
      break
    case 'error':
    case 'returned_to_sender':
    case 'wrong_address':
    case 'electronic.refused':
    case 'electronic.locked':
    case 'electronic.not_distributed':
    case 'electronic.failed_external':
      color = colors[2]
      error = lrar.error
      break
    default:
      color = colors[4]
  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'flex-start',
          fontSize: 12,
        }}
      >
        <span
          onClick={(e) => {
            e.preventDefault()
            getPreviewFile(lrar.file)
          }}
          style={{ cursor: 'pointer' }}
        >
          <RemoveRedEye style={{ color: color, marginRight: 5 }} />
        </span>
        <span
          style={{ cursor: 'pointer' }}
          onClick={(e) => {
            e.preventDefault()
            getPreviewFile(lrar.sending_proof)
          }}
        >
          {lrar.sending_proof ? (
            <ReceiptSharp style={{ color: colors[0] }} />
          ) : (
            <>&nbsp;</>
          )}
        </span>
        <span
          style={{ cursor: 'pointer' }}
          onClick={(e) => {
            e.preventDefault()
            getPreviewFile(lrar.signature_proof)
          }}
        >
          {lrar.signature_proof ? (
            <VerifiedSharp style={{ color: colors[0] }} />
          ) : (
            <>&nbsp;</>
          )}
        </span>
      </Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'flex-start',
          flexDirection: 'column',
        }}
      >
        {lrar.type?.toUpperCase()}
      </Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'flex-start',
          flexDirection: 'column',
        }}
      >
        <span>
          {error
            ? error
            : lrar.status
            ? translate(`hs.convocation.${lrar.status}`, { _: lrar.status })
            : ''}
        </span>
      </Box>
      {/* // if diff empty property proof return icon workspacepremium */}
    </Box>
  )
}
export const handleDigital = (
  convocation,
  ag_id,
  navigate,
  translate,
  getPreviewFile
) => {
  const digital = convocation.digital
  if (!digital) {
    return null
  }
  let color = colors[4]
  let signed = false
  if (digital.status === 'sent') {
    color = colors[4]
  }
  if (digital.status === 'signed') {
    color = colors[0]
    signed = true
  }
  if (digital.status === 'signer_viewed') {
    color = colors[1]
  }
  if (digital.status === 'declined') {
    color = colors[2]
  }
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'flex-start',
          fontSize: 12,
        }}
      >
        <span
          onClick={(e) => {
            getPreviewFile(digital.file)
          }}
          style={{ cursor: 'pointer' }}
        >
          <RemoveRedEye style={{ color: color, marginRight: 5 }} />
        </span>
        <span
          style={{ cursor: 'pointer' }}
          onClick={(e) => {
            e.preventDefault()
            getPreviewFile(digital.sending_proof)
          }}
        >
          {digital.sending_proof ? (
            <ReceiptSharp style={{ color: colors[0] }} />
          ) : (
            <>&nbsp;</>
          )}
        </span>
        <span
          style={{ cursor: 'pointer' }}
          onClick={(e) => {
            e.preventDefault()
            getPreviewFile(digital.signature_proof)
          }}
        >
          {digital.signature_proof ? (
            <VerifiedSharp style={{ color: colors[0] }} />
          ) : (
            <>&nbsp;</>
          )}
        </span>
      </Box>
      <Box
        sx={{
          fontSize: 12,
        }}
      >
        <span>
          {digital.status
            ? translate(`hs.convocation.${digital.status}`, {
                _: digital.status,
              })
            : ''}
        </span>
      </Box>
      {digital.reminded_at && (
        <Box
          sx={{
            fontSize: 12,
          }}
        >
          Relancé le {moment(digital.reminded_at).format('DD/MM/YYYY à HH:mm')}
        </Box>
      )}
    </Box>
  )
}

export const getAddress = (contact) => {
  const line3 = [
    contact?.adresse?.postalCode,
    contact?.adresse?.city,
    contact?.adresse?.country,
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <>
      {contact?.adresse?.line1}
      {contact?.adresse?.line1 && <br />}
      {contact?.adresse?.line2}
      {contact?.adresse?.line2 && <br />}
      {line3}
    </>
  )
}

export const handleContact = (contact, translate) => {
  const name = [contact?.firstname, contact?.lastname]
    ?.filter(Boolean)
    ?.join(' ')
  const address = getAddress(contact)
  return (
    <>
      {name} {handleRoles(contact.roles, translate)} <br />
      {address}
      {address && <br />}
      {contact?.email} {contact?.email && <br />}
    </>
  )
}

const DigitalConsent = ({ value }) => {
  let color = value ? 'rgb(102, 187, 106)' : 'rgb(244, 67, 54)'
  return (
    <span
      style={{
        background: `${color}`,
        color: 'white',
        marginLeft: 10,
        padding: '3px 10px',
        borderRadius: '5px',
      }}
    >
      Consentement digital {!value ? 'refusé' : ''}
    </span>
  )
}

export const handleCoproprietaire = (convocation) => {
  return (
    <>
      {convocation.coowner.name}
      <DigitalConsent value={convocation.coowner.digital_consent} />
    </>
  )
}
export const handleStatus = (status) => {
  // null / error / done / pending
  let color = null
  if (status === 'done') {
    color = colors[0]
  }
  if (status === 'error') {
    color = colors[2]
  }
  if (status === 'pending') {
    color = colors[1]
  }
  return color ? <CheckIcon style={{ color: color }} /> : null
}
export const handleRoles = (roles, translate) => {
  return (
    <>
      {roles?.map((role) => {
        return (
          <span
            style={{
              background:
                bgRoles.find((item) => item.role == role)?.bg || 'grey',
              color: 'white',
              marginLeft: 10,
              padding: '3px 10px',
              borderRadius: '5px',
            }}
          >
            {role ? translate(`hs.convocation.${role}`, { _: role }) : ''}
          </span>
        )
      })}
    </>
  )
}
